import { useSearchParams } from 'next/navigation'
import React from 'react'
import { SIGN_IN_EXPERT_TRADE_ROUTES } from 'shared-constants'
import SignInClient from '@client/routes/SignInClient'
import SignInExpert from '@expert/routes/SignInExpert'
import { Tabs } from 'components/Tabs'

const tabs = [
  { label: 'Clients', content: <SignInClient /> },
  { label: 'Experts and Trade', content: <SignInExpert /> },
]

export const SignInTabs: React.FC = () => {
  const searchParams = useSearchParams()

  const type = searchParams.get('type')
  const isTradeOrExpert = (
    SIGN_IN_EXPERT_TRADE_ROUTES as readonly string[]
  ).includes(type)

  return (
    <Tabs.Root defaultValue={tabs[isTradeOrExpert ? 1 : 0].label}>
      <Tabs.List aria-label="Manage sign in account">
        {tabs.map(({ label }) => (
          <Tabs.Tab value={label} key={label}>
            {label}
          </Tabs.Tab>
        ))}
      </Tabs.List>
      {tabs.map(({ label, content }) => (
        <Tabs.Content value={label} key={label}>
          {content}
        </Tabs.Content>
      ))}
    </Tabs.Root>
  )
}
